import axios from "axios";
import VueCookies from 'vue-cookies';
import {isAuthenticatedCookie} from "@/auth/sanctum/constants";
import appSettings from "@/mixins/config/appSettings";
import {version} from '../../package'

export const VersionedAPIPath = '/api/' + appSettings.data().appSettings.PLATFORM_BACKEND_API_VERSION;

//INSTANCE USES BASEURL, THIS BECAUSE SANCTUM AUTHENTICATES VIA WEB ROUTES
//VersionedAPIPath Needs to be used for the Routes that require it everything with /api/version/...
let instance = axios.create({
    withCredentials: true,
    baseURL: appSettings.data().appSettings.PLATFORM_BACKEND_BASE_URL
});

instance.interceptors.request.use(request => {
    request.headers.common['Application-Version'] = version;
    request.headers.common['Application-Id'] = appSettings.data().appSettings.applicationID;
    request.headers.common['Accept'] = 'application/json';
    request.headers.common['Content-Type'] = 'application/json';
    return request;
});

instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        let status = error.response.status;
        //403 BAIL WHEN NOT FROM LOGIN SHIT
        if (status === 401 ||
            status === 419 ||
            (status === 403 && error.response.request.responseURL.indexOf('/login') == -1))
        {
            VueCookies.remove(isAuthenticatedCookie);
            window.location.reload();
        }

        return Promise.reject(error);
    }
);


export default instance;